// PostHog only runs on the production landing host. Without this, local dev
// and the Amplify preview build reported into the production project: over
// the 90 days to 2026-07-31, localhost:5173-5176, 127.0.0.1, an ngrok tunnel
// and dev.d2jmq2z5cpfldx.amplifyapp.com all show up in its host breakdown.
// The app is gated separately to app.neosearch.neobim.ai.

const PRODUCTION_HOSTS = new Set(["neosearch.neobim.ai"]);

let warned = false;

export function isAnalyticsHost(): boolean {
  if (typeof window === "undefined") return false;
  if (PRODUCTION_HOSTS.has(window.location.hostname)) return true;
  if (!warned) {
    warned = true;
    console.info(
      `[analytics] disabled on ${window.location.hostname} — production host only`,
    );
  }
  return false;
}
